import React from "react";
import { Dialog, DialogContent, DialogActions, Button } from "@mui/material";
import "./ConfirmationDialog.scss";

interface ConfirmationDialogProps {
    /** Controls whether the dialog is open */
    open: boolean;
    
    /** Callback when dialog is closed */
    onClose: () => void;
    
    /** Title/heading of the dialog */
    title: string;
    
    /** Description/message of the dialog */
    message: string;
    
    /** Optional: Additional message to display below the main message */
    additionalMessage?: string;
    
    /** Text for the cancel button (default: "Cancel") */
    cancelButtonText?: string;
    
    /** Text for the confirm button (default: "Confirm") */
    confirmButtonText?: string;
    
    /** Callback when confirm button is clicked */
    onConfirm: () => void;
    
    /** Optional: Color for the confirm button (default: primary) */
    confirmButtonColor?: string;
}

/**
 * Reusable confirmation dialog component for Phone to CNP flows.
 * Displays a title, message, and Cancel/Confirm buttons.
 */
export const ConfirmationDialog: React.FC<ConfirmationDialogProps> = (props) => {
    const cancelButtonText = props.cancelButtonText ?? "Cancel";
    const confirmButtonText = props.confirmButtonText ?? "Confirm";
    const confirmButtonColor = props.confirmButtonColor ?? "#D32F2F";

    return (
        <Dialog
            open={props.open}
            onClose={props.onClose}
            PaperProps={{
                className: 'confirmation-dialog'
            }}
        >
            <DialogContent className="confirmation-dialog-content">
                <h2 className="confirmation-dialog-title">
                    {props.title}
                </h2>
                <p className="confirmation-dialog-message">
                    {props.message}
                </p>
                {props.additionalMessage && (
                    <p className="confirmation-dialog-message">
                        {props.additionalMessage}
                    </p>
                )}
            </DialogContent>
            <DialogActions className="confirmation-dialog-actions">
                <Button
                    onClick={props.onClose}
                    variant="outlined"
                    className="confirmation-dialog-button confirmation-dialog-cancel-button"
                >
                    {cancelButtonText}
                </Button>
                <Button
                    onClick={props.onConfirm}
                    variant="contained"
                    className="confirmation-dialog-button confirmation-dialog-confirm-button"
                    style={{ backgroundColor: confirmButtonColor }}
                >
                    {confirmButtonText}
                </Button>
            </DialogActions>
        </Dialog>
    );
};
